const newLoginUser = 
{
    "username": "studentX",
    "password": "passwordX",
    "role": "player",
    "accountNbr": "88888888"
}

export default newLoginUser;